module.exports = __webpack_public_path__ + "static/img/1-4.a209c61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/1-4.png
// module id = 1309
// module chunks = 0